import React from 'react';

interface BlurredContentProps {
  isBlurred: boolean;
  children: React.ReactNode;
  className?: string;
}

const BlurredContent: React.FC<BlurredContentProps> = ({
  isBlurred,
  children,
  className = '',
}) => {
  if (!isBlurred) {
    return <div className={className}>{children}</div>;
  }

  return (
    <div className={`relative ${className}`}>
      <div
        className="filter blur-lg opacity-60 pointer-events-none"
        style={{ filter: 'blur(8px)' }}
      >
        {children}
      </div>
      <div className="absolute inset-0 bg-white bg-opacity-30 pointer-events-none" />
    </div>
  );
};

export default BlurredContent;
